import { post } from '@/base/http-base'

export function bindWechat(data) {
  return post('/openApi/user/bindWechat', data)
}
